<template>
  <div v-if="show" class="modal fade show custom-modal-backdrop" aria-modal="true" role="dialog" @click.self="onCancel">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-items-center">
              <h1 class="mb-0">Activity Log: {{ item.name }}</h1>
              <div class="d-flex align-items-center gap-2">
                <button
                    @click="onCancel"
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-0">
        <div class="modal-body pt-0">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead class="table-light">
                <tr>
                  <th>Date</th>
                  <th class="text-center">Hours</th>
                  <th>Task Note</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading">
                  <td colspan="3" class="text-center py-2">
                    <span class="spinner-border spinner-border-sm me-1"></span> Loading activity logs...
                  </td>
                </tr>
                <tr v-else v-for="log in logs" :key="log.id">
                  <td>{{ formatDate(log.date) }}</td>
                  <td class="text-center">{{ log.hours }}</td>
                  <td>{{ log.full_description || '-' }}</td>
                </tr>
                <tr v-if="!loading && logs.length === 0">
                  <td colspan="3" class="text-center py-5">
                    <div class="text-center">
                        <i class="fas fa-clipboard-list mb-1 fs-1 text-muted"></i>
                        <p class="text-muted">No activity logs found for this activity.</p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer pt-0 border-top-0">
          <button type="button" class="btn btn-secondary" @click="onCancel">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue';
import handleCompanyContact from "@/services/modules/companyContact";
import { useRoute } from "vue-router";

const props = defineProps({
  show: Boolean,
  item: Object
});

const emit = defineEmits(['update:show']);
const { fetchActivityLogsList } = handleCompanyContact();
const route = useRoute();

const logs = ref([]);
const loading = ref(false);

const onCancel = () => {
  emit('update:show', false);
};

const fetchLogs = async () => {
  if (!props.item?.id) return;
  
  loading.value = true;
  try {
    const query = `?company_id=${route.params.companyId}&project_id=${props.item.project_id}&project_account_id=${props.item.id}`;
    const response = await fetchActivityLogsList(query);
    if (response.status) {
      logs.value = response.data;
    }
  } catch (error) {
    console.error("Error fetching activity logs:", error);
  } finally {
    loading.value = false;
  }
};

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

watch(() => props.show, (newVal) => {
  if (newVal) {
    fetchLogs();
  } else {
    logs.value = [];
  }
});
</script>

<style scoped>
.custom-modal-backdrop {
  display: block;
  background-color: rgba(28, 29, 28, 0.2);
  z-index: 1060;
}

.modal-content {
  border-radius: 0.358rem;
}

h1 {
  font-size: 1.25rem;
}

.modal-lg {
  max-width: 800px;
}

.table thead th {
    border-top: none;
    text-transform: uppercase;
    font-size: 0.8rem;
    letter-spacing: 0.5px;
}
</style>
